export default {
  "AgreementModalAdvertising.Name": "広告目的でのIPアドレス利用",
  "AgreementModalAdvertising.Detail1":
    "ドコモは、以下に記載のドコモが取得しているお客さまの情報を、以下に記載の利用目的を達成するために必要な範囲で利用します",
  "AgreementModalAdvertising.Detail2": "【利用情報】",
  "AgreementModalAdvertising.Detail3":
    "お客さまがご契約中のドコモの通信回線で、各種サイトに接続、または各種アプリ＊を利用した際に、ドコモが発行するIPアドレス",
  "AgreementModalAdvertising.Detail4":
    "ドコモの広告計測タグを設定したサイト又はアプリ（他社サイト・アプリを含みます）に限ります。以下「対象サイト・アプリ」といいます",
  "AgreementModalAdvertising.Detail5": "【利用方法】",
  "AgreementModalAdvertising.Detail6":
    "ドコモが発行したIPアドレスによりお客さまを識別のうえ、ドコモ独自の広告専用IDを生成します",
  "AgreementModalAdvertising.Detail7":
    "生成した広告専用IDを、お客さまがご利用の端末のブラウザ内に書きこむ等の方法により、当該端末に広告専用IDを記録します",
  "AgreementModalAdvertising.Detail8":
    "その後、お客さまが当該端末から対象サイト・アプリへ接続した際に、当該広告専用IDをドコモが確認することで、お客さまを識別し、下記利用目的のために利用します",
  "AgreementModalAdvertising.Detail9": "【利用目的】",
  "AgreementModalAdvertising.Detail10":
    "広告専用IDに対応するお客さまの属性情報等（*1）に応じてドコモが推奨する「ドコモ広告(*2)」を配信するため",
  "AgreementModalAdvertising.Detail11":
    "対象サイト・アプリにおける広告の効果測定等を行うため",
  "AgreementModalAdvertising.Detail12":
    "お客さまがご利用中のドコモの通信回線、または各種サービス等のご契約・ご利用等に関する情報をもとに、ドコモがお客さまの趣味趣向その他属性等を推定し、生成された情報となります。氏名や住所等のお客さま個人を特定できる情報を含みません",
  "AgreementModalAdvertising.Detail13":
    "「ドコモ広告」は、ドコモ及び他社の各種サイト・アプリ上で表示される広告の右上に「docomo広告」のアイコンがついている広告です（一部の広告配信事業者が配信する広告や動画広告等、アイコンが付いていない場合もあります）「ドコモ広告」に関する詳しい説明は",
  "AgreementModalAdvertising.LinkText1": "こちら",
  "AgreementModalAdvertising.Detail14":
    "「ドコモ広告」の配信や対象サイト・アプリにおける広告効果測定等を行うための、IPアドレス利用に関する詳しい説明は",
  "AgreementModalAdvertising.LinkText2": "こちら",
  "AgreementModalAdvertising.Detail15": "【ご注意事項】",
  "AgreementModalAdvertising.Detail16": "お客さまの同意状況は、いつでも「",
  "AgreementModalAdvertising.LinkText3": "パーソナルデータダッシュボード",
  "AgreementModalAdvertising.Detail17":
    "」で確認・変更いただくことができます（パーソナルデータダッシュボードの仕様は随時見直すことがあります）",
  "AgreementModalAdvertising.Detail18":
    "同意されない場合でも、IPアドレスを利用せずにお客さまの属性情報等に応じてドコモが推奨する「ドコモ広告」等の配信は止まりません（全ての「ドコモ広告」の推奨配信を止めるためには、",
  "AgreementModalAdvertising.LinkText4": "「ドコモ広告」説明サイト",
  "AgreementModalAdvertising.Detail19":
    "「4.データ利用の管理」から設定方法をご確認ください）",
  "AgreementModalAdvertising.Detail20":
    "「ドコモ広告」以外のドコモからのおすすめ、ご案内、広告については、本同意状態にかかわらず、それぞれのアプリ・サイト・その他の各媒体でご説明している内容に基づき配信されます",
}
